<template>
  <div class="tableBtn">
    <b-button id="cancelBtn" pill size="sm" @click="onClick"
      ><slot><i class="bi bi-x icon cancelBtnIcon"></i></slot
    ></b-button>
  </div>
</template>

<script>
export default {
  name: 'CancelButton',
  methods: {
    onClick() {
      this.$emit('clickEvent')
    }
  }
}
</script>

<style lang="scss" scoped>
$icon-color: white;

.cancelBtnIcon {
  font-size: 16px;
  color: $icon-color;
}
</style>
